function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { feedbackErrorClassName, feedbackErrorMessage } from "../../../../helpers/errorUtils";
import _ from "lodash";
import { AvFeedback } from "availity-reactstrap-validation";

class TmFeedback extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        error,
        field,
        errorKey,
        positive
      } = this.props;
      return /*#__PURE__*/React.createElement(AvFeedback, {
        className: feedbackErrorClassName(error, _.camelCase(errorKey || field))
      }, feedbackErrorMessage(error, _.camelCase(field), _.camelCase(errorKey || field), !!positive ? `${_.startCase(field)} must be positive.` : `${_.startCase(field)} is required.`));
    });
  }

}

export default TmFeedback;